<template>
    <div>
        <nav v-if="items.length > 0 && $route.name != 'checkout' && $route.name != 'login' && $route.name != 'checkoutdone'" class="navbar navbar-inverse navbar-fixed-bottom bg-info nav-footer-index">
            <div class="container">
                <div class="navbar-header navbar-right">
                    <router-link id="cart-checkout-bar-button" class="navbar-brand pull-right btn btn-primary" to="/checkout">{{$t("Proceed to Checkout") }} <i class="fa fa-arrow-right"></i></router-link>
                    <button type="button" class="navbar-toggle pull-left cart-mobile-menu-button" data-toggle="collapse" data-target="#cart-navbar-collapse">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                </div>
                <div class="collapse navbar-collapse" id="cart-navbar-collapse">
                    <ul class="nav navbar-nav shopping-cart">
                        <li class="dropdown" v-if="items.length > 0">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i class="fa fa-shopping-cart"></i> ${{ total }} ({{ items.length }} {{ $t('Items') }})<span class="caret"></span></a>
                            <ul class="dropdown-menu dropdown-menu-left">
                                <li v-for="item in items">
                                    <a :href="item.url"><div type="button" class="clickable btn btn-xs btn-danger" @click.stop.prevent="deleteItem(item)" title="Remove from cart"><i class="fa fa-remove"></i></div> <span class="item-cost">${{parseFloat(item.price).toFixed(2)}}</span> {{item.title}}</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <component v-if="optionsComponent" :is="optionsComponent" :key="counter" :item="item" class="cart-options-modal modal"></component>
    </div>
</template>

<script>
    import CourseOptions from './Cart/CourseOptions.vue';
    export default {
        name: 'cart',
        data() {
            return {
                items: [],
                interval: null,
                optionsComponent: false,
                counter: 0,
                item: null,
            };
        },
        computed:{
            total() {
                let total = 0;
                for(let i in this.items)
                {
                    let item = this.items[i];
                    total += parseFloat(item.price);
                }
                return parseFloat(total).toFixed(2);
            }
        },
        watch: {
        },
        components: {},
        methods: {
            addItem(item) {
                var callback = () => {};
                if(item.callback !== undefined)
                {
                    callback = item.callback;
                    delete item.callback;
                }
                this.counter++;
                switch(item.type)
                {
                    case 'course':
                        this.optionsComponent = CourseOptions;
                        this.item = item;
                        this.$nextTick(() => {
                            $(this.$el).find(".cart-options-modal").modal('show');
                        });
                        callback(true);
                        break;
                    default:
                        this.$http.post('/api/cart', {item: item, options: {}}).then(response => {
                            if(response.data.success)
                            {
                                this.items.push(response.data.item);

                                if(this.items.length == 1)
                                {
                                    this.$nextTick(() => {
                                        $("#cart-checkout-bar-button").popover({
                                            trigger: "manual",
                                            content: this.$t("Add more items to your cart and/or click here to checkout whenever you're ready."),
                                            placement: "top",
                                        });
                                        $("#cart-checkout-bar-button").popover('show');
                                        $(document).click(e => {
                                            $("#cart-checkout-bar-button").popover('hide');
                                        });
                                    });
                                }
                            }
                            else
                            {
                                this.$alert(null, {
                                    title: this.$t("Alert"),
                                    message: response.data.error,
                                    confirm: this.$t("I Understand"),
                                });
                            }
                            callback(response.data.success);
                        });
                        break;
                }
            },
            deleteItem(item)
            {
                this.$http.delete('/api/cart/' + item.id).then(response => {
                    this.items.splice(this.items.indexOf(item), 1);
                });
            },
            refresh() {
                this.$http.get('/api/cart').then(response => {
                    this.items = response.data.items;
                });
            },
        },
        mounted()
        {
            this.refresh();
            this.$root.bus.$on('cart:add', this.addItem);
            this.$root.bus.$on('cart:refresh', this.refresh);
            //this.interval = setInterval(this.refresh, 30000);
        },
        beforeDestroy()
        {
            clearInterval(this.interval);
        },
    }
</script>

<style>
    .nav-footer-index {
        z-index:4;
    }
    
    .shopping-cart {
        position: relative;
        z-index: 1001;
    }

    .item-cost {
        display: inline-block;
        margin-right: 20px;
        margin-left: 20px;
        width: 50px;
        text-align: right;
    }

    .cart-mobile-menu-button {
        margin-left: 15px;
    }

    #cart-checkout-bar-button {
        border-radius: 0
    }

    #cart-checkout-bar-button:hover {
        background-color: #006eb1;
    }
</style>